// Reusable themed confirmation modal using existing modal styles
// Exported for use across pages. Example:
//   const ok = await openConfirmModal({ title: 'Confirm', message: 'Proceed?', confirmText: 'Yes', cancelText: 'No' });
export function openConfirmModal({
  title = 'Confirm',
  message = 'Are you sure?',
  confirmText = 'Yes',
  cancelText = 'Cancel',
  confirmClass = ''
} = {}) {
  return new Promise((resolve) => {
    try {
      const ov = document.createElement('div');
      ov.className = 'modal-overlay';
      const confirmBtnClass = ['menu-btn', confirmClass].filter(Boolean).join(' ');
      ov.innerHTML = `
        <div class="modal-dialog" role="dialog" aria-modal="true">
          <h3 style="margin-top:0;">${title}</h3>
          <p style="margin-top: 0.5rem;">${message}</p>
          <div class="modal-actions">
            <button id="confirm_ok" class="${confirmBtnClass}">${confirmText}</button>
            <button id="confirm_cancel" class="menu-btn">${cancelText}</button>
          </div>
        </div>
      `;
      let onKey;
      const cleanup = (val) => {
        try { window.removeEventListener('keydown', onKey); } catch {}
        try { ov.remove(); } catch {}
        resolve(val);
      };
      ov.addEventListener('click', (e) => { if (e.target === ov) cleanup(false); });
      document.body.appendChild(ov);
      const okBtn = ov.querySelector('#confirm_ok');
      const cancelBtn = ov.querySelector('#confirm_cancel');
      okBtn?.addEventListener('click', () => cleanup(true));
      cancelBtn?.addEventListener('click', () => cleanup(false));
      onKey = (ev) => { if (ev.key === 'Escape') { ev.preventDefault(); cleanup(false); } };
      window.addEventListener('keydown', onKey);
    } catch {
      // Fallback to native confirm if anything goes wrong
      resolve(confirm(message));
    }
  });
}

export function openInfoModal({
  title = 'Notice',
  message = '',
  okText = 'OK'
} = {}) {
  return new Promise((resolve) => {
    try {
      const ov = document.createElement('div');
      ov.className = 'modal-overlay';
      ov.innerHTML = `
        <div class="modal-dialog" role="dialog" aria-modal="true">
          <h3 style="margin-top:0;">${title}</h3>
          <p style="margin-top: 0.5rem;">${message}</p>
          <div class="modal-actions">
            <button id="info_ok" class="menu-btn">${okText}</button>
          </div>
        </div>
      `;
      let onKey;
      const cleanup = () => {
        try { window.removeEventListener('keydown', onKey); } catch {}
        try { ov.remove(); } catch {}
        resolve(true);
      };
      ov.addEventListener('click', (e) => { if (e.target === ov) cleanup(); });
      document.body.appendChild(ov);
      const okBtn = ov.querySelector('#info_ok');
      okBtn?.addEventListener('click', cleanup);
      try { okBtn?.focus(); } catch {}
      onKey = (ev) => {
        if (ev.key === 'Escape' || ev.key === 'Enter') {
          ev.preventDefault();
          cleanup();
        }
      };
      window.addEventListener('keydown', onKey);
    } catch {
      alert(message);
      resolve(true);
    }
  });
}

export default { openConfirmModal, openInfoModal };
